import { render, staticRenderFns } from "./admin-message-dialog.vue?vue&type=template&id=443af89f"
import script from "./admin-message-dialog.vue?vue&type=script&lang=js"
export * from "./admin-message-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports